export enum EReportChart {
  LINE = 'LINE',
  GROUP_BAR = 'GROUP_BAR',
  SIMPLE_BAR = 'SIMPLE_BAR',
}
